import React, { useEffect } from 'react';
import { Loader2 } from 'lucide-react';
import { useAuth } from '@/auth/AuthProvider';
import { useNavigate } from 'react-router-dom';

const OidcCallbackPage: React.FC = () => {
  const auth = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (auth.isAuthenticated) {
      navigate('/agreements');
    }
  }, [auth.isAuthenticated, navigate]);

  if (auth.isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-50">
        <div className="flex flex-col items-center gap-3">
          <Loader2 className="h-8 w-8 animate-spin text-slate-400" aria-hidden="true" />
          <p className="text-sm text-slate-500">Autenticando...</p>
        </div>
      </div>
    );
  }

  if (auth.error) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-50 px-4">
        <div
          role="alert"
          className="w-full max-w-sm rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-800"
        >
          Erro de autenticação: {auth.error.message}
        </div>
      </div>
    );
  }

  return null;
};

export default OidcCallbackPage;
